import { AuthState } from "./interfaces";

export default (): AuthState => ({
    loggedIn: false,
    loginError: ''
});